module.exports = require("./lib/browser/Jobin.js");